import { Lock } from '@mui/icons-material';
import React from 'react';

const BlockedScreen = ({ onRetry }) => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 relative overflow-hidden">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-lg w-full text-center border border-gray-200">
        <div className="flex justify-center mb-6">
          <div className="p-4 bg-red-100 rounded-full shadow-md">
            <Lock className="h-12 w-12 text-red-500" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Access Restricted
        </h1>

        <p
          style={{
            color: '#4b5563',
            fontSize: '14px',
            lineHeight: '1.6',
            marginBottom: '24px'
          }}
        >
          Your current IP address is not permitted to access the application. If
          this seems unexpected, please reach out to support at{' '}
          <a
            href="tel:+916262306306"
            style={{
              color: '#007bff',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
          >
            +91 6262-306306
          </a>
          .
        </p>

        <button
          onClick={onRetry}
          className="
            px-6 py-3 rounded-xl text-white font-medium 
            bg-red-500 hover:bg-red-600 
            transition-all duration-200 shadow-md hover:shadow-lg"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default BlockedScreen;
